var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPsColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3379 1392",
    width: 274,
    height: 113,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#193560}.b{fill:#fbb315}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1468.5 115.1h93v98.3h122.4v103.6h-122.3v201.4c0 0-7.3 56.2 51.7 53.4 59-2.8 78.7-16.9 78.7-16.9v106.7c0 0-140.6 54.6-223.5-3.5 0 0-49.2-32.9-49.2-117.2v-221.3h-59v-58.5l73.1-49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2229.4 677.2h146.4v-677.2h-21.8c-71.3-0.1-129 58-128.5 129.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m992.1 212.1h103.9l22.6 75.8h8.5c0 0 44.9-103.9 177-78.6l-11.2 132.1c0 0-108.8-28.9-148.8 45.6-7.8 14.5-11.4 31-11.4 47.5v241.3h-140.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1791.8 244.4l42.1 95.5c0 0 112.4-56.2 168.7-25.3 0 0 30.9 8.5 25.3 70.3h143.3c0 0 5.6-104-56.2-146.2-61.8-42.1-154.6-36.5-154.6-36.5 0 0-112.4 8.4-168.6 42.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2041.9 609.8l30.9 67.4h98.5v-292.3h-143.5l1 79.3 1.9 145.6h11.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1940.7 472c0 0 24.5-9.9 88.1-7.8v46.5c0 0-1 68.1-82.5 71v95.5c0 0 53.4-5.6 95.6-67.4l28.1-120.9-16.9-45-25.3-59-87.1 1.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1891.1 531.1c0 0-6.6 55.5 60.9 50.2v95.9c0 0-90 22.5-149-16.9-59-39.3-56.2-101.1-56.2-140.5 0-39.3 22.5-128.3 193.9-133h18l-18 85.2c0 0-50.1 7.1-49.6 59.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2036.3 604.1h14v11.3h-14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m706.9 205c0 0 229.1-19.7 227.6 243.8-1.4 246.7-227.6 234.2-227.6 234.2v-107.1c0 0 85.7 7.2 82.9-124.9-2.8-132.1-45-134.1-82.9-138.7v-107.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m706.9 203.9c0 0-229.2-19.7-227.7 243.8 1.4 246.7 227.7 234.1 227.7 234.1v-107c0 0-85.8 7.1-82.9-125 2.8-132.1 44.9-134 82.9-138.7v-107.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m691.1 203.6c0 0 36.5-2 71.1 5.3l-42.7 105c0 0-47.1-7.2-72 24.9-25 32.1-27.8-10.1-27.8-10.1 0 0 71.4-125.1 71.4-125.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m557 634.4c0 0 70.4 72.2 211.3 42.1l-18-114.2c0 0-20.1 16.6-59.9 10.9l-48.2 73.1-85.2-11.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2.8 40.6c0 0 45 115.2 146.2 123.7h73c0 0 70.3-2.8 75.9 73.1 5.7 75.8-53.4 87.1-53.4 87.1 0 0-16.8 8.4-44.9 8.4h-47.5l-0.3-137.7c0 0-81.5 2.8-151.8-95.6v575.8h149.2v-217.6h75.7c0 0 147 0.9 200-107 52.9-107.8 7.9-203.4 7.9-203.4 0 0-32.7-106.8-207.5-106.8 0 0-222.5 0-222.5 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1940.7 912.4c0 0 229.2-19.7 227.7 243.8-1.4 246.7-227.7 234.1-227.7 234.1v-107c0 0 85.7 7.1 82.9-124.9-2.8-132.1-45-134.1-82.9-138.7v-107.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1940.7 911.3c0 0-229.2-19.7-227.7 243.8 1.5 246.6 227.7 234.1 227.7 234.1v-107c0 0-85.7 7.1-82.9-125 2.8-132.1 45-134 82.9-138.7 0 0 0-107.2 0-107.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1925 911c0 0 36.5-2 71 5.3l-42.6 105c0 0-47.2-7.2-72.1 24.9-24.9 32.1-27.7-10.1-27.7-10.1 0 0 71.3-125.1 71.4-125.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1790.9 1341.8c0 0 70.3 72.2 211.3 42l-18-114.1c0 0-20.2 16.6-60 10.9l-48.2 73.1-85.1-11.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2478.1 948l42.2 95.5c0 0 112.4-56.2 168.6-25.3 0 0.1 30.9 8.5 25.3 70.3h143.4c0 0 5.6-104-56.3-146.1-61.8-42.2-154.5-36.6-154.5-36.6 0 0-112.5 8.4-168.7 42.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2728.3 1313.4l30.9 67.4h98.5v-292.3h-143.5l1 79.3 1.8 145.6h11.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2627.1 1175.7c0 0 24.4-10 88.1-7.8v46.4c0 0-1 68.2-82.5 71v95.5c0 0 53.4-5.6 95.6-67.4l28.1-120.9-16.9-44.9-25.3-59.1-87.1 1.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2577.4 1234.7c0 0-6.5 55.5 60.9 50.2v95.9c0 0-89.9 22.5-148.9-16.8-59.1-39.4-56.3-101.2-56.3-140.6 0-39.3 22.5-128.3 194-133h18l-18 85.3c0 0-50.1 7-49.7 59z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2722.6 1307.8h14.1v11.2h-14.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2377.8 1378.5v-675.3c0 0-108.5-12.2-143.7 78.1-5.9 15.2-8.6 31.5-8.6 47.9v549.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m593 896.3l46.4-117.9c0 0-229.1-116.6-369.6 15.5 0 0-44.9 36.5-50.6 123.6-6.3 98.4 73.1 151.8 123.7 177.1 50.6 25.3 146.1 59 149 101.2 2.8 42.1-31 59-31 59 0 0-67.4 36.5-247.3-45v137.7c0 0 193.9 81.6 323.2 14.1 78.5-41 99.5-111.3 103.9-160.3 3.5-39.4-7.8-78.5-32.2-109.6-23.5-29.9-63.3-65.7-129.3-90.4-133.5-50.1-111-92.2-108.2-103.5 2.8-11.2 30.9-59 123.7-33.7 92.7 25.3 98.3 32.2 98.3 32.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3066 1376.9v-675.2c0 0-108.5-12.2-143.7 78-5.9 15.2-8.6 31.5-8.6 47.9v549.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3378.3 1378.5h-151.6v-290.2c0 0-3-78-78.9-72.6-75.8 5.4-81.8 97.6-81.8 97.6v-146.7c0 0 36.5-70.8 156.1-63.3 119.7 7.6 150.6 93.6 153.4 139.3 2.8 45.7 2.8 140.4 2.8 140.4v195.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3226.7 1085.8c0 0 5.4-71.5-65.5-86.9l2.1-6.9 45 11.2 28.1 28.1v44.7l-9.7 9.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3157.6 998.8c0 0 2.3-0.4 11 2 8.8 2.4-8.1-6-8.1-6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1338.8 1382.9v-675.2c0 0-108.5-12.2-143.7 78-5.9 15.2-8.6 31.6-8.6 47.9v549.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1519.1 885.2h174.3l-222.1 227.6 234.7 265.6h-177l-197.1-246.6 6.9-48.4 180.3-198.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m840.4 1091.8c5.6-25.3 11.2-78.7 72.6-86.2 61.4-7.5 82 46.8 82 46.8h117.5q-0.3-1.3-0.4-2.8c-0.7-12.5-7.6-23.7-13.1-34.7-5.5-11.2-11.3-22.1-18.4-32.4-3.8-5.6-2.8-11.1 0.5-15-36.1-36.3-93.7-64.7-168.1-61.7-129.7 5.1-199.1 82-212.9 186-13.7 104 2.5 238.9 145.9 281 143.3 42.2 258.6-19.6 258.6-19.6v-106.8c0 0-70.3 39.3-168.7 36.5-98.4-2.8-95.5-98.4-95.5-98.4h289.4v-92.7h-289.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m942.5 906.2c0 0 155 4.3 183.1 147.6 0 0 5.7 25.3 5.7 70.3 0 44.9-1.5 60.4-1.5 60.4l-35.1-26.7-95.5-64.6c0 0 4.3-53-37.2-78.5l48.4-5.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2714.3 1082h143v24h-143z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2028.3 379h143v25h-143z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPsColor);
export default __webpack_public_path__ + "static/media/logo-ps-color.5323212f3940b5966e17a5fe0ed64918.svg";
export { ForwardRef as ReactComponent };